import type { Address } from '@/bizComponents/AddressBook'
import type { IFormValues } from '@/containers/Order/Create/type'
import type { AddressInfoType, AutoSplitAddressType } from '@/services/api/address/types'
import type { OutboundsGetRes } from '@/services/api/order/type'

/** 格式化收货地址表单值 */
export const formatConsigneeAddressToFormValuesByAutoSplit = (addressInfo: AutoSplitAddressType) => {
  return {
    consigneeCountry: addressInfo?.countryCode,
    consigneeName: addressInfo?.name,
    consigneeAddress: addressInfo?.address,
    consigneeEmail: addressInfo?.email,
    consigneeMobile: `${addressInfo?.areaCode || ''}${addressInfo?.phoneNum || ''}`,
    consigneeProvince: addressInfo?.province,
    consigneeCity: addressInfo?.city,
    consigneeDistrict: addressInfo?.district,
    consigneeZipCode: addressInfo?.zipCode,
  }
}

export const TranslateMap = {
  consigneeCountry: 'countryCode' as const,
  consigneeName: 'name' as const,
  consigneeAddress: 'address' as const,
  consigneeEmail: 'email' as const,
  consigneeMobile: 'mobile' as const,
  consigneeProvince: 'province' as const,
  consigneeCity: 'city' as const,
  consigneeDistrict: 'district' as const,
  consigneeZipCode: 'zipCode' as const,

  consigneeAddressTwo: 'addressTwo' as const,
  zipCode: 'consigneeZipCode' as const,
  district: 'consigneeDistrict' as const,
  city: 'consigneeCity' as const,
  province: 'consigneeProvince' as const,
  mobile: 'consigneeMobile' as const,
  email: 'consigneeEmail' as const,
  address: 'consigneeAddress' as const,
  name: 'consigneeName' as const,
  countryCode: 'consigneeCountry' as const,
}

export const formatConsigneeAddressToFormValuesByAddressBook = (addressInfo: Address) => {
  return {
    consigneeCountry: addressInfo?.countryCode,
    consigneeName: addressInfo?.name,
    consigneeAddress: addressInfo?.address,
    consigneeAddressTwo: addressInfo?.addressTwo,
    consigneeEmail: addressInfo?.email,
    consigneeMobile: addressInfo?.mobile,
    consigneeProvince: addressInfo?.province,
    consigneeCity: addressInfo?.city,
    consigneeDistrict: addressInfo?.district,
    consigneeZipCode: addressInfo?.zipCode,
  }
}

export const formatAddressBookItemFormConsigneeAddress = (values: IFormValues, addressType = 2) => {
  return {
    countryCode: values.consigneeCountry,
    name: values.consigneeName,
    address: values.consigneeAddress,
    addressTwo: values.consigneeAddressTwo,
    email: values.consigneeEmail,
    mobile: values.consigneeMobile,
    province: values.consigneeProvince,
    city: values.consigneeCity,
    district: values.consigneeDistrict,
    zipCode: values.consigneeZipCode,
    addressType,
  } as Address
}

export const formatAddressBookItemFormRefundAddress = (values: AddressInfoType, addressType = 3) => {
  return {
    countryCode: values.countryCode,
    name: values.name,
    address: values.address,
    addressTwo: values.addressTwo,
    email: values.email,
    mobile: values.mobile,
    province: values.province,
    city: values.city,
    district: values.district,
    zipCode: values.zipCode,
    addressType,
  } as Address
}

const areaKey = ['consigneeProvince', 'consigneeCity', 'consigneeDistrict']
/** 格式化店配三级地址层级 */
export const formatConsigneeAddressToStoreArea = (area: Partial<Pick<OutboundsGetRes['logistics'], 'consigneeProvince' | 'consigneeCity' | 'consigneeDistrict'>>) => {
  const resArr = areaKey.reduce((sum, curKey) => {
    const value = area[curKey]
    if (!!value) {
      sum.push(value)
    }
    return sum
  }, [])
  return resArr?.length ? resArr : undefined
}

/** 地址展示 */
export const formatAddressToShow = (info, type: 'sender' | 'consignee') => {
  const consigneeKeys = ['consigneeCountry', ...(info.consigneeCountry !== 'SG' ? areaKey : []), 'consigneeAddress', 'consigneeAddressTwo', 'consigneeZipCode']
  const senderKeys = [
    'senderCountry',
    ...(info.senderCountry !== 'SG' ? ['senderProvince', 'senderCity', 'senderDistrict'] : []),
    'senderAddress',
    'senderAddressTwo',
    'senderZipCode',
  ]
  return (type === 'sender' ? senderKeys : consigneeKeys)
    .map((k) => info[k])
    .filter(Boolean)
    .join(' ')
}
